import { render } from "./CannotConnectToClinicModal.vue?vue&type=template&id=5a063abf&scoped=true&ts=true"
import script from "./CannotConnectToClinicModal.vue?vue&type=script&lang=ts"
export * from "./CannotConnectToClinicModal.vue?vue&type=script&lang=ts"

import "./CannotConnectToClinicModal.vue?vue&type=style&index=0&id=5a063abf&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a063abf"]])

export default __exports__